import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { BrowserCompatibilityService } from './browser-compatibility.service';

@Injectable({
  providedIn: 'root'
})
export class CompatibleBrowserGuard implements CanLoad {

  constructor(private browserCompatibilityService: BrowserCompatibilityService) {

  }

  canLoad(route, segments) {
    return this.browserCompatibilityService.isBrowserCompatible();
  }
}
